import { useEffect, useState } from 'react';
import { useCategory } from '../store/category';

interface SubCategory {
  id: string;
  header: string;
  isActive: boolean;
}

interface Category {
  id: string;
  name: string;
  isActive: boolean;
  subCategories: SubCategory[];
}

interface FlattenedCategory {
  id: string;
  name: string;
  subCategories: SubCategory[];
}

export const useCategoryListQuery = () => {
  const { listAll } = useCategory();
  const [categories, setCategories] = useState<FlattenedCategory[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<null | Error>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = listAll.response;

        if (res?.data) {
          const filtered = res.data
            .filter((cat: Category) => cat.isActive && cat.name)
            .map((cat) => ({
              id: cat.id,
              name: cat.name,
              subCategories: (cat.subCategories || []).filter(
                (sub) => sub.isActive && sub.header
              ),
            }));

          setCategories(filtered);
        }
      } catch (err: any) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [listAll]);

  return { categories, isLoading, error };
};
